// 资源管理表木
const url = '/business/yhSeedling/'
const url2 = '/business/yhMaintainRecord/'
// /** 新增苗木 */
// insertYhSeedling: string;
// /** 修改苗木 */
// updateYhSeedling: string;
// /** 删除苗木 */
// deleteYhSeedling: string;
// /** 查询苗木详情 */
// selectYhSeedlingBySeedlingId: string;
// /** 分页查询苗木列表 */
// selectYhSeedlingByPage: string;
// /** 导出 */
// exportSeedlingData: string;
// /** 导入苗木 */
// importYhSeedling: string;
// /** 查询苗木打点列表 */
// selectYhSeedlingLocationList: string;
// /** 查询苗木汇总(名称、类别、等级) */
// selectYhSeedlingSum: string;
// /** 项目苗木汇总列表 */
// selectYsProjectSumList: string;
export default {
  // 云养护
  insertYhSeedling: url + 'insertYhSeedling',
  updateYhSeedling: url + 'updateYhSeedling',
  deleteYhSeedling: url + 'deleteYhSeedling',
  selectYhSeedlingBySeedlingId: url + 'selectYhSeedlingBySeedlingId',
  selectYhSeedlingByPage: url + 'selectYhSeedlingByPage',
  exportSeedlingData: url + 'exportSeedlingData',
  importYhSeedling: url + 'importYhSeedling',
  selectYhSeedlingLocationList: url + 'selectYhSeedlingLocationList',
  selectYhSeedlingSum: url + 'selectYhSeedlingSum',
  selectYsProjectSumList: url + 'selectYsProjectSumList',
  // 新增养护档案
  insertYhMaintainRecord: url2 + 'insertYhMaintainRecord',
  // 批量新增养护档案
  insertAllYhMaintainRecord: url2 + 'insertAllYhMaintainRecord',
  // 修改养护档案
  updateYhMaintainRecord: url2 + 'updateYhMaintainRecord',
  // 删除养护档案
  deleteYhMaintainRecord: url2 + 'deleteYhMaintainRecord',
  // 分页查询养护档案列表
  selectYhMaintainRecordByPage: url2 + 'selectYhMaintainRecordByPage',
  // 养护档案列表
  statisticsMaintain: url2 + 'statisticsMaintain'
}
